import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import { apiRequest } from '../../utils/apiClient';
import { useNavigate } from 'react-router-dom';
import { useVendorContext} from '../../context/VendorContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const [isResetMode, setIsResetMode] = useState(false);
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { setVendorDetails } = useVendorContext();

  const handleLogin = async () => {
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await apiRequest(`/auth/login`, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: {
          vendor: username,
          password,
        },
      });

      if (!response) {
        setError('❗Invalid username or password.');
        return;
      }
      const { token, vendor, role, branch } = response;
      setVendorDetails({ token, vendor, role, branch } as any);
      localStorage.setItem('jwtToken', token);

      setMessage('✅ Login successful!');
      navigate('/');
    } catch (err) {
      setError('❌ Invalid username or password.');
    } finally {
      setIsLoading(false);
    }
  };

  const toggleResetMode = () => {
    setMessage('');
    setError('');
    setIsResetMode(!isResetMode);
  };

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, md: 8 } }}>
      <Paper elevation={4} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
          {isResetMode ? 'Reset Password' : 'Login'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          Sign in to manage products, orders, offers, and quotations.
        </Typography>

        {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box display="flex" flexDirection="column" gap={2.2}>
          <TextField
            label="Vendor name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
          />
          {!isResetMode && (
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
            />
          )}

          {!isResetMode ? (
            <>
              <Button
                variant="contained"
                onClick={handleLogin}
                disabled={isLoading || !username || !password}
                startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
                size="large"
              >
                {isLoading ? 'Logging in...' : 'Login'}
              </Button>
              <Button onClick={toggleResetMode} disabled={isLoading}>
                Forgot Password?
              </Button>
            </>
          ) : (
            <>
              <Button variant="contained" disabled>
                Send Reset Link
              </Button>
              <Button onClick={toggleResetMode}>
                Back to Login
              </Button>
            </>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default LoginPage;
